import { render, staticRenderFns } from "./ResponsibleTable.vue?vue&type=template&id=682310a0&scoped=true"
import script from "./ResponsibleTable.vue?vue&type=script&lang=js"
export * from "./ResponsibleTable.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleTable.vue?vue&type=style&index=0&id=682310a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682310a0",
  null
  
)

export default component.exports